const getFromQueryString = ( a_name ) =>
{
	const results = new RegExp( `[\\?&]${a_name}=([^&#]*)` ).exec( window.location.search );
	
	if ( results == null )
	{
		return null;
	}
	
	return decodeURI( results[ 1 ] ) || null;
	
};

export default getFromQueryString;